import * as yup from 'yup';

export const CompanyBenefitInputs = {
    DESCRIPTION: "description",
    START_DATE: "start_date",
    END_DATE: "end_date",
    TYPE: "type",
    CONTRIBUTION_PERIOD: "contribution_period",
    COMPANY_CONTRIBUTION_1: "company_contribution_1",
    COMPANY_CONTRIBUTION_2: "company_contribution_2"
}

export const companyBenefitSchema = yup.object({
    [CompanyBenefitInputs.DESCRIPTION]: yup.string().required('This is required'),
    [CompanyBenefitInputs.START_DATE]: yup.date().required('This is required'),
    [CompanyBenefitInputs.END_DATE]: yup.date().required('This is required'),
    [CompanyBenefitInputs.TYPE]: yup.string().required('This is required'),
    [CompanyBenefitInputs.CONTRIBUTION_PERIOD]: yup.string().required('This is required'),
    [CompanyBenefitInputs.COMPANY_CONTRIBUTION_1]: yup.string().required('This is required'),
    [CompanyBenefitInputs.COMPANY_CONTRIBUTION_2]: yup.string().required('This is required'),
});

export const EmployeeBenefitInputs = {
    ASSIGNED_EMPLOYEE: "assigned_employee",
    START_DATE: "start_date",
    END_DATE: "end_date",
    COMPANY_BENEFIT: "company_benefit",
    TYPE: "type",
    CONTRIBUTION_PERIOD: "contribution_period",
    COMPANY_CONTRIBUTION_1: "company_contribution_1",
    COMPANY_CONTRIBUTION_2: "company_contribution_2"
}

export const employeeBenefitSchema = yup.object({
    [EmployeeBenefitInputs.ASSIGNED_EMPLOYEE]: yup.string().required('This is required'),
    [EmployeeBenefitInputs.START_DATE]: yup.date().required('This is required'),
    [EmployeeBenefitInputs.END_DATE]: yup.date().required('This is required'),
    [EmployeeBenefitInputs.COMPANY_BENEFIT]: yup.string().required('This is required'),
    [EmployeeBenefitInputs.TYPE]: yup.string().required('This is required'),
    [EmployeeBenefitInputs.CONTRIBUTION_PERIOD]: yup.string().required('This is required'),
    [EmployeeBenefitInputs.COMPANY_CONTRIBUTION_1]: yup.string().required('This is required'),
    [EmployeeBenefitInputs.COMPANY_CONTRIBUTION_2]: yup.string().required('This is required'),
});